
import { initializeApp } from 'firebase/app';
import { initializeAuth, getAuth, getReactNativePersistence, GoogleAuthProvider, TwitterAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import AsyncStorage from '@react-native-async-storage/async-storage';

// تكوين Firebase الصحيح
const firebaseConfig = {
  apiKey: "AIzaSyCbZ8plcn_G3KspmoS3ZpEebnt51eurPug", // API key من google-services.json
  authDomain: "swalfna.com",
  projectId: "swalfna-a8fb8",
  storageBucket: "swalfna-a8fb8.firebasestorage.app",
  messagingSenderId: "39512678906",
  appId: "1:39512678906:web:65e48cc22a9a1522e78443",
  measurementId: "G-6MLLDF4MNZ"
};

// تهيئة Firebase
const app = initializeApp(firebaseConfig);

// تهيئة المصادقة مع AsyncStorage persistence
let auth;
try {
  // للتطبيقات المحلية، استخدم AsyncStorage
  auth = initializeAuth(app, {
    persistence: getReactNativePersistence(AsyncStorage)
  });
} catch (error) {
  // للويب، استخدم الإعداد العادي
  auth = getAuth(app);
}

export { auth };
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export const twitterProvider = new TwitterAuthProvider();

// إعداد Google Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
